export default "__VITE_ASSET___j85mtS9__"